import ModalForgottenPassword from "./ModalForgottenPassword"

export default ModalForgottenPassword